import { Props } from 'shared/@types';
import { MarkdownView } from 'shared/components/markdown-view';
import { PageContent } from 'shared/components/page-content';

function stripLeadingMarkdownHeading(markdown: string) {
  return markdown.replace(/^\s*#\s+[^\r\n]*(?:\r?\n)+/, '').trimStart();
}

export function MarkdownPage({
  markdown,
  variant = 'page',
}: Props<{
  markdown: string;
  variant?: 'page' | 'modal';
}>) {
  const content = variant === 'modal' ? stripLeadingMarkdownHeading(markdown) : markdown;

  return (
    <PageContent
      nativeSafeTop={variant !== 'modal'}
      className={variant === 'modal' ? 'px-3 pb-6 pt-3 md:px-6 md:pb-12 md:pt-6' : undefined}
      contentClassName={variant === 'modal' ? 'max-w-screen-md' : undefined}
    >
      <MarkdownView
        markdown={content}
        className={
          variant === 'modal'
            ? 'mx-auto w-full'
            : 'border-brand-brown-dark/10 mx-auto rounded-lg border bg-white p-3 md:p-6'
        }
      />
    </PageContent>
  );
}
